import Service from "./Service";
const resource = "/pin";

export default {
  async getAll() {
    const resp = await Service.get(`${resource}`);
    const data = resp.data;

    return data;
  }
};
